module.exports = __webpack_public_path__ + "img/guangbo_icon.16e3400f.png";